import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import './index.css';
import { InvitationsProvider } from './contexts/context';
import { AuthProvider } from './contexts/auth-context';

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {posthogKey ? (
      <PostHogProvider client={posthog}>
        <AuthProvider>
          <InvitationsProvider>
            <App />
          </InvitationsProvider>
        </AuthProvider>
      </PostHogProvider>
    ) : (
      <AuthProvider>
        <InvitationsProvider>
          <App />
        </InvitationsProvider>
      </AuthProvider>
    )}
  </React.StrictMode>
);

